import { defineApi } from '@/services/api/defineApi';
import { attachRequestIdInterceptor } from '@/services/api/interceptors';

// `a=1&a=2`, not axios's default `a[]=1&a[]=2`.
const serializeRepeatedArrays = (params: Record<string, unknown>): string =>
  new URLSearchParams(
    Object.entries(params).flatMap(([key, value]): Array<[string, string]> => {
      if (value === undefined || value === null) return [];
      return Array.isArray(value) ? value.map((v) => [key, String(v)]) : [[key, String(value)]];
    }),
  ).toString();

// The AP (Accounts Payable) API — the default client. Replaces the former
// singleton apiClient + getConfig.
export const apApi = defineApi('ap');

// The payment API — different baseURL + headers, configured at boot by
// paymentApiClientInitializer.
export const payApi = defineApi('pay');

// The events service (dokka-events) — its own host prefix (`/events/v1/`) instead
// of the AP `/v2/{client}/`, and its own query-string dialect. It is FastAPI,
// which reads a list as repeated `users=a&users=b` and ignores the bracketed form
// axios emits by default, while AP endpoints on apApi need the brackets they have
// always been sent (documents aggregations rides on `subtags[]`). One axios
// instance cannot speak both, so the dialect alone would already justify a
// separate client. Same auth headers as AP; configured at boot by
// @/initializers/apiClientInitializer.
export const eventsApi = defineApi('events');
eventsApi.client.defaults.paramsSerializer = { serialize: serializeRepeatedArrays };

// The bank-feed service — its own host prefix (`/bankfeed/v1/`) instead of the
// AP `/v2/{client}/`. Same auth headers as AP; configured at boot by
// @/initializers/apiClientInitializer.
export const bankFeedApi = defineApi('bankFeed');

// dokka-pay requires an `X-Request-Id` on every request for log correlation.
// Attached to the pay client only — the AP API does not send it.
attachRequestIdInterceptor(payApi.client);
